import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import TableCell from "@mui/material/TableCell";
import Box from "@mui/material/Box";
import FindReplaceIcon from "@mui/icons-material/FindReplace";
import Tooltip from "@mui/material/Tooltip";
import TableConfigurator from "./TableConfigurator";

const TableCellWrapper = ({ onClickSearch, value, cellProps, style }) => (
  <TableCell
    sx={[theme => ({ px: 2 }), onClickSearch ? { cursor: "pointer" } : null].filter(Boolean)}
    id={value}
    {...cellProps()}
    onClick={onClickSearch ? () => onClickSearch() : null}
  >
    <Box sx={{ display: "flex", maxWidth: "100%", flexWrap: "wrap" }}>
      {value !== -1 ? value : "-"}
      {onClickSearch ? (
        <Box sx={{ justifyContent: "flex-end", display: "flex", flexGrow: 1 }} style={style}>
          <FindReplaceIcon />
        </Box>
      ) : null}
    </Box>
  </TableCell>
);

const CellComponent = ({ value, onClickSearch, toolTip, type, item }) => {
  const [ownValue, setOwnValue] = useState(undefined);
  const updateIntervalRef = useRef(undefined);
  useEffect(() => {
    const computeValue = () => (value === -1 && type === "date" ? "-" : TableConfigurator[item].value(value));

    setOwnValue(computeValue());

    // If this is a date cell, refresh the computed value every minute.
    if (type === "date" && value !== -1) {
      updateIntervalRef.current = setInterval(() => {
        setOwnValue(computeValue());
      }, 60000);
    }

    return () => {
      if (updateIntervalRef.current !== undefined) {
        clearInterval(updateIntervalRef.current);
        updateIntervalRef.current = undefined;
      }
    };
  }, [value, type, item]);
  const [style, setStyle] = useState({ color: "rgba(0, 0, 0, 0)" });
  const cellProps = () => {
    return onClickSearch
      ? {
          onMouseEnter: () => setStyle({ color: "rgba(0, 0, 0, 0.54)" }),
          onMouseLeave: () => setStyle({ color: "rgba(0, 0, 0, 0)" }),
        }
      : {};
  };
  const inner = <TableCellWrapper onClickSearch={onClickSearch} value={ownValue} cellProps={cellProps} style={style} />;
  return !toolTip ? (
    inner
  ) : (
    <Tooltip
      title={toolTip}
      enterDelay={1000}
      placement="top"
      slotProps={{
        tooltip: {
          sx: {
            fontSize: "0.7rem",
            m: 0,
          },
        },
      }}
    >
      {inner}
    </Tooltip>
  );
};

CellComponent.defaultProps = {
  onClickSearch: undefined,
  toolTip: undefined,
  type: undefined,
};

CellComponent.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onClickSearch: PropTypes.func,
  toolTip: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  item: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  translation: state.ui.translation,
});

const Cell = connect(mapStateToProps)(CellComponent);

export default Cell;
